import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
    // Scroll to top on page load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Pricing plans data (same as PricingSection)
    const plans = [
        {
            id: 1,
            name: 'عرض الحصري',
            price: '2500',
            unit: 'جنيه / متر',
            description: 'تشطيب مميز بخامات عالية الجودة وضمان مدى الحياة بأسعار تنافسية',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 2 ملي – 3 ملي – 4 ملي)',
                'سباكة الشريف أو BR ماركة معتمدة (التوصيل يتم رفعه مع شهادة ضمان)',
                'عزل أرضيات الحمامات بضمان مدى الحياة',
                'مادة الأساس بطبقة أسمنتية مع شهادة ضمان',
                'ديكورات فوم إيطالي لجميع الديكورات',
                'ترميم محارة (الخدمة خاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم وتنفيذ سقف جبس عادي حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل للون',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت 1.6 و4 ملي بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة (قطعة BS ستارة ومفتاح) حسب الدور والارتفاع واختيار اللون المناسب',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'دهانات بيت فايبر حسب اختيار العميل للشكل',
                'عرض شامل كامل للغرف والريسبشن'
            ],
            recommended: false,
            color: '#e67e22'
        },//2500
        {
            id: 2,
            name: 'عرض المناسب',
            price: '3000',
            unit: 'جنيه / متر',
            description: 'عرض مميز لتشطيب السقف الجبسي والإضاءة بتفاصيل عالية الجودة وضمان مدى الحياة',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 3 ملي – 4 ملي)',
                'مفاتيح كهرباء بساس أو فينوس أو لوجي بضمان مدى الحياة',
                'سلك التليفزيون والريسيفر BR معتمد مع شهادة ضمان',
                'أنظمة إضاءة مضمونة مدى الحياة',
                'مادة الأساس بطبقة أسمنتية مع شهادة ضمان',
                'ديكورات فوم إيطالي لجميع الأشكال',
                'سبوتات إضاءة (اللمبات خاصة بالعميل)',
                'تصميم وتنفيذ سقف معلق ثلاثي الأبعاد حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت (1.6 – 4 – 6 ملي) بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة مع ستارة ومفتاح حسب التصميم',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'بيت مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)'
            ],
            recommended: false,
            color: '#3498db'
        },//3000
        {
            id: 3,
            name: 'عرض المميز',
            price: '3500',
            unit: 'جنيه / متر',
            description: 'تشطيب مميز بخامات فاخرة وتفاصيل دقيقة وضمان مدى الحياة في جميع الأعمال',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 3 ملي – 4 ملي)',
                'مفاتيح كهرباء بساس أو فينوس أو لوجي بضمان مدى الحياة',
                'سلك التليفزيون أو BR ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات بضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم إيطالي لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم وتنفيذ سقف معلق ثلاثي الأبعاد حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل للون',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت 1.6 و4 ملي بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة (قطعة BS ستارة ومفتاح) حسب الدور والارتفاع واختيار اللون المناسب',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'دهانات بيت فايبر حسب اختيار العميل للشكل',
                'بيت مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'توريد وتركيب طقم حمام (ديورافيت أو إيديال ستاندرد أو تركي معتمد)',
                'خلاطات حمام ومطبخ من نوع (ديورافيت أو إيديال ستاندرد أو كلودي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل'
            ],
            recommended: true,
            color: '#1abc9c'
        },// 3500
        {
            id: 4,
            name: 'عرض الفاخر',
            price: '4200',
            unit: 'جنيه / متر',
            description: 'تشطيب فاخر بخامات عالية الجودة وتفاصيل دقيقة مع ضمان مدى الحياة في معظم البنود',
            features: [
                'سلك سويدي معتمد (0.5 ملم – 1 ملم – 2 ملم – 4 ملم)',
                'مفاتيح كهرباء سانشي أو فابريس أو فينوس بضمان مدى الحياة',
                'سلك أو شريط BR أو ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات ضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم فاناتر لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والداخلي للإضاءة فقط)',
                'تصميم مركز إنارة خاص للعميل يشمل كرت إنارة 4 هام ورباعي',
                'تصميم سقف معلق ثلاثي الأبعاد (سيستم + جبس + بليت + ليزر) حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس – جوتن – بايت – GLC) حسب اختيار العميل للون',
                'ساسية معجون مميزة (لون – سعر – تربة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمرة 1.6 ملم و4 ملم للسمنتج والطريقة',
                'كريستال BS (بيت النور الرئيسي والفرعي مع ستارة ومفتاح) حسب الدور والارتفاع واللون المناسب',
                'نيشة فايبر حسب اختيار العميل للشكل',
                'بيت فايبر مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'طقم حمام كامل (قاعدة – مرحاض – بانيو – أحواض) من ديورافيت أو إيديال ستاندرد أو تيرو الإيطالي',
                'خلاطات حمام ومطبخ (كلودي – إيديال – مخلوط من النادي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل',
                'عزل صوت التكييف حسب الكتالوج والفرز المطلوب'
            ],
            recommended: false,
            color: '#9b59b6'
        },//4200
        {
            id: 5,
            name: 'عرض الفخامة',
            price: '5000',
            unit: 'جنيه / متر',
            description: 'تشطيب فخم بخامات عالية الجودة وتفاصيل دقيقة وضمانات ممتدة لمعظم البنود',
            features: [
                'سلك سويدي معتمد (0.5 ملم – 1 ملم – 2 ملم – 3 ملم – 4 ملم)',
                'مفاتيح كهرباء سانشي أو فابريس أو لوجي بضمان مدى الحياة',
                'سلك تليفزيون BR أو ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات بضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم فاناتر لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم مركز إنارة خاص للعميل يشمل كرت إنارة 4 هام ورباعي',
                'تصميم سقف معلق ثلاثي الأبعاد (سيستم – جبس – بليت – ليزر) حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس – جوتن – بايت – GLC) حسب اختيار العميل للون',
                'ساسية معجون مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمرة 1.6 و4 ملم بالسمنت والطريقة',
                'نيشة BS رئيسية وفرعية ستارة ومفتاح حسب الارتفاع والدور واختيار اللون المناسب',
                'أبواب PVC حسب اختيار العميل للشكل',
                'نيشة فايبر مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'طقم حمام (قاعدة – بانيو – أحواض – كابينة شاور) من ديورافيت أو إيديال ستاندرد أو تيرو الإيطالي',
                'خلاطات حمام ومطبخ (ديورافيت – إيديال – كلودي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل',
                'أرضيات HDF حسب اختيار العميل للشكل واللون',
                'ديكورات حجر حسب الاختيار (العرض خاص بالكتالوجات أو الفرش والرسم)'
            ],
            recommended: false,
            color: '#f1c40f'
        },//5000


    ];


    // Form state
    const [formData, setFormData] = useState({
        area: '',
        plan: 'اقتصادي',
        rooms: '',
        bathrooms: '',
        kitchens: '',
        balconies: ''
    });

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission to WhatsApp
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate form
        if (!formData.area || !formData.rooms || !formData.bathrooms || !formData.kitchens || !formData.balconies) {
            alert('الرجاء ملء جميع الحقول المطلوبة');
            return;
        }

        // Create WhatsApp message
        const message = `
🏠 *طلب عرض سعر تشطيب*

📏 *المساحة:* ${formData.area} متر مربع
🎨 *نوع التشطيب:* ${formData.plan}
🚪 *عدد الغرف:* ${formData.rooms}
🚿 *عدد الحمامات:* ${formData.bathrooms}
🍳 *عدد المطابخ:* ${formData.kitchens}
🏡 *عدد البلكونات:* ${formData.balconies}

أرجو تزويدي بعرض سعر تفصيلي.
        `.trim();

        // Encode message for URL
        const encodedMessage = encodeURIComponent(message);
        const whatsappURL = `https://wa.me/+201111505503?text=${encodedMessage}`;

        // Open WhatsApp
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="pricing-page">
            <div className="page-header">
                <div className="header-overlay"></div>
                <div className="container">
                    <div className="header-content">
                        <span className="header-badge">
                            <i className="fas fa-tags"></i>
                            عروض خاصة
                        </span>
                        <h1>الأسعار والخطط</h1>
                        <p>باقات تشطيب تناسب جميع الميزانيات</p>
                    </div>
                </div>
            </div>

            <section className="pricing-plans-section">
                <div className="container">

                    <div className="section-header">
                        <span className="section-tag">اختر ما يناسبك</span>
                        <h2>باقات التشطيب</h2>
                        <p>اختر الباقة المناسبة لاحتياجاتك</p>
                    </div>
                    <div className="payment-terms-section">
                        <div className="payment-terms-header">
                            <div className="payment-icon-wrapper">
                                <i className="fas fa-hand-holding-usd"></i>
                            </div>
                            <h3>شطب وانت مرتاح... واستلم على المفتاح 🏠</h3>
                            <p className="payment-subtitle">أنظمة دفع مرنة تناسب الجميع</p>
                        </div>

                        <div className="payment-options-grid">
                            <div className="payment-option highlight">
                                <div className="payment-badge">الأكثر طلباً</div>
                                <div className="payment-icon">
                                    <i className="fas fa-calendar-alt"></i>
                                </div>
                                <h4>تقسيط على 24 شهر</h4>
                                <div className="payment-details">
                                    <div className="payment-detail-item">
                                        <i className="fas fa-check-circle"></i>
                                        <span>مقدم يبدأ من 25%</span>
                                    </div>
                                    <div className="payment-detail-item">
                                        <i className="fas fa-check-circle"></i>
                                        <span>تقسيط بدون فوائد نهائياً</span>
                                    </div>
                                    <div className="payment-detail-item">
                                        <i className="fas fa-check-circle"></i>
                                        <span>أطول فترة سداد حتى 24 شهر</span>
                                    </div>
                                </div>
                            </div>

                            <div className="payment-option">
                                <div className="payment-icon">
                                    <i className="fas fa-money-bill-wave"></i>
                                </div>
                                <h4>الدفع كاش</h4>
                                <div className="payment-details">
                                    <div className="payment-detail-item">
                                        <i className="fas fa-check-circle"></i>
                                        <span>خصم 15% على السعر الإجمالي</span>
                                    </div>
                                    <div className="payment-detail-item">
                                        <i className="fas fa-check-circle"></i>
                                        <span>دفع فوري بخصم مميز</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="payment-benefits">
                            <h4>مميزات العمل معنا</h4>
                            <div className="benefits-grid">
                                <div className="benefit-item">
                                    <i className="fas fa-handshake"></i>
                                    <span>هنكون معاك خطوة بخطوة لحد ما نسلمك على المفتاح</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="fas fa-user-tie"></i>
                                    <span>فريق عمل متكامل من المهندسين والفنيين على أعلى مستوى</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="fas fa-clock"></i>
                                    <span>دقة في التنفيذ وسرعة في الأداء</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="fas fa-gem"></i>
                                    <span>أفضل الخامات المستخدمة بالضمان الشامل</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="fas fa-search"></i>
                                    <span>معاينة مجانية 🔥</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="fas fa-tags"></i>
                                    <span>باقات مختلفة تناسب جميع الأذواق وأسعار في متناول الجميع</span>
                                </div>
                            </div>
                        </div>

                        <div className="payment-contact">
                            <p>للاستعلام والمعاينة المجانية 📲📞</p>
                            <div className="contact-numbers">
                                <a href="tel:01111505503" className="contact-number">
                                    <i className="fas fa-phone"></i>
                                    <span>01111505503</span>
                                </a>
                                <a href="tel:01055556363" className="contact-number">
                                    <i className="fas fa-phone"></i>
                                    <span>01055556363</span>
                                </a>
                            </div>
                            <div className="whatsapp-contact">
                                <a href="https://wa.me/+201111505503" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-whatsapp"></i>
                                    تواصل عبر واتساب
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="pricing-grid">
                        {plans.map(plan => (
                            <div
                                className={`pricing-card ${plan.recommended ? 'recommended' : ''}`}
                                key={plan.id}
                                style={{ '--plan-color': plan.color }}
                            >
                                {plan.recommended && (
                                    <div className="recommended-badge">
                                        <i className="fas fa-star"></i>
                                        الأكثر طلبًا
                                    </div>
                                )}

                                <div className="card-header">
                                    <div className="plan-icon">
                                        <i className="fas fa-home"></i>
                                    </div>
                                    <h3>{plan.name}</h3>
                                    <p className="plan-description">{plan.description}</p>
                                </div>

                                <div className="card-price">
                                    <div className="price-wrapper">
                                        <span className="currency">EGP</span>
                                        <span className="price">{plan.price}</span>
                                        <span className="unit">{plan.unit}</span>
                                    </div>
                                </div>

                                <div className="card-features">
                                    <div className="features-header">
                                        <i className="fas fa-list-check"></i>
                                        <span>جميع المميزات ({plan.features.length})</span>
                                    </div>
                                    <ul className="features-list">
                                        {plan.features.map((feature, index) => (
                                            <li key={index}>
                                                <i className="fas fa-check"></i>
                                                <span>{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="card-action">
                                    <Link to="/contact" className="btn-choose">
                                        <span>احجز الآن</span>
                                        <i className="fas fa-arrow-left"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="pricing-info-cards">
                        <div className="info-card">
                            <i className="fas fa-shield-alt"></i>
                            <h4>ضمان شامل</h4>
                            <p>ضمان 5 سنوات على جميع الأعمال</p>
                        </div>
                        <div className="info-card">
                            <i className="fas fa-hand-holding-usd"></i>
                            <h4>تقسيط مرن</h4>
                            <p>خيارات دفع متعددة تناسب ميزانيتك</p>
                        </div>
                        <div className="info-card">
                            <i className="fas fa-tools"></i>
                            <h4>خامات عالية</h4>
                            <p>نستخدم أفضل المواد والخامات</p>
                        </div>
                    </div>



                    <div className="pricing-note">
                        <i className="fas fa-info-circle"></i>
                        <p>* الأسعار تقريبية وقد تختلف حسب متطلبات المشروع والمواد المستخدمة</p>
                    </div>
                </div>
            </section>

            <section className="calculator-section">
                <div className="container">
                    <div className="section-header">
                        <h2>احصل على عرض سعر مخصص</h2>
                        <p>املأ البيانات وسنرسل لك عرض سعر تفصيلي عبر الواتساب</p>
                    </div>

                    <div className="quote-form-container">
                        <form className="quote-form" onSubmit={handleSubmit}>
                            <div className="form-grid">
                                <div className="form-group">
                                    <label htmlFor="area">
                                        <i className="fas fa-ruler-combined"></i>
                                        المساحة (متر مربع) *
                                    </label>
                                    <input
                                        type="number"
                                        id="area"
                                        name="area"
                                        min="1"
                                        placeholder="أدخل المساحة"
                                        value={formData.area}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="plan">
                                        <i className="fas fa-paint-roller"></i>
                                        نوع التشطيب *
                                    </label>
                                    <select
                                        id="plan"
                                        name="plan"
                                        value={formData.plan}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="اقتصادي">اقتصادي</option>
                                        <option value="لوكس">لوكس</option>
                                        <option value="هاي لوكس">هاي لوكس</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="rooms">
                                        <i className="fas fa-door-closed"></i>
                                        عدد الغرف *
                                    </label>
                                    <input
                                        type="number"
                                        id="rooms"
                                        name="rooms"
                                        min="0"
                                        placeholder="عدد الغرف"
                                        value={formData.rooms}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="bathrooms">
                                        <i className="fas fa-bath"></i>
                                        عدد الحمامات *
                                    </label>
                                    <input
                                        type="number"
                                        id="bathrooms"
                                        name="bathrooms"
                                        min="0"
                                        placeholder="عدد الحمامات"
                                        value={formData.bathrooms}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="kitchens">
                                        <i className="fas fa-utensils"></i>
                                        عدد المطابخ *
                                    </label>
                                    <input
                                        type="number"
                                        id="kitchens"
                                        name="kitchens"
                                        min="0"
                                        placeholder="عدد المطابخ"
                                        value={formData.kitchens}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="balconies">
                                        <i className="fas fa-border-style"></i>
                                        عدد البلكونات *
                                    </label>
                                    <input
                                        type="number"
                                        id="balconies"
                                        name="balconies"
                                        min="0"
                                        placeholder="عدد البلكونات"
                                        value={formData.balconies}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-submit">
                                <button type="submit" className="btn btn-whatsapp">
                                    <i className="fab fa-whatsapp"></i>
                                    إرسال عبر الواتساب
                                </button>
                                <p className="form-note">* سيتم فتح الواتساب مباشرة مع رسالة تحتوي على بياناتك</p>
                            </div>
                        </form>

                        <div className="form-benefits">
                            <h3>لماذا تطلب عرض سعر من تشطيب؟</h3>
                            <ul>
                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    <span>عرض سعر مفصل ودقيق حسب احتياجاتك</span>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    <span>استشارة مجانية من خبرائنا</span>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    <span>ضمان شامل على جميع الأعمال</span>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    <span>خيارات تقسيط مرنة</span>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    <span>فريق عمل محترف وخبرة 15 عام</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="faq-section">
                <div className="container">
                    <div className="section-header">
                        <h2>الأسئلة الشائعة</h2>
                        <p>إجابات على الأسئلة الأكثر شيوعًا</p>
                    </div>

                    <div className="faq-list">
                        <div className="faq-item">
                            <h3>ما هي مدة تنفيذ المشروع؟</h3>
                            <p>تختلف مدة تنفيذ المشروع حسب حجمه ونوع التشطيب، ولكن بشكل عام تتراوح المدة بين 3-6 أشهر للشقق السكنية.</p>
                        </div>

                        <div className="faq-item">
                            <h3>هل يمكنني تقسيط تكلفة المشروع؟</h3>
                            <p>نعم، نوفر خيارات تقسيط مرنة تناسب ميزانيتك، حيث يمكنك دفع التكلفة على دفعات مرتبطة بمراحل تنفيذ المشروع.</p>
                        </div>

                        <div className="faq-item">
                            <h3>هل تقدمون ضمان على الأعمال المنفذة؟</h3>
                            <p>نعم، نقدم ضمان شامل لمدة سنة على جميع الأعمال المنفذة، وضمان لمدة 5 سنوات على أعمال السباكة والكهرباء.</p>
                        </div>

                        <div className="faq-item">
                            <h3>هل يمكنني تعديل الباقة حسب احتياجاتي؟</h3>
                            <p>بالتأكيد، يمكننا تصميم باقة مخصصة تناسب احتياجاتك وميزانيتك، حيث نضيف أو نحذف بعض الخدمات حسب رغبتك.</p>
                        </div>

                        <div className="faq-item">
                            <h3>هل تقدمون خدمات التصميم الداخلي؟</h3>
                            <p>نعم، نقدم خدمات التصميم الداخلي بشكل منفصل أو كجزء من باقة التشطيب الشاملة، مع تصورات ثلاثية الأبعاد للتصميم النهائي.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pricing-cta-section">
                <div className="container">
                    <div className="pricing-cta">
                        <h2>جاهز لبدء مشروعك؟</h2>
                        <p>تواصل معنا الآن للحصول على استشارة مجانية وعرض سعر تفصيلي لمشروعك.</p>
                        <Link to="/contact" className="btn btn-primary">تواصل معنا</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Pricing;
